/**
 * 用于保存 class 的元数据
 */
export class Annotations {
    constructor() {
        this.classes = new Map();
        this.props = new Map();
        this.methods = new Map();
        this.params = new Map();
    }
    setClassMetadata(token, params) {
        this.classes.set(token, params);
    }
    getClassMetadata(token) {
        return this.classes.get(token);
    }
    getClassMetadataKeys() {
        return Array.from(this.classes.keys());
    }
    pushParamMetadata(token, params) {
        if (!this.params.has(token)) {
            this.params.set(token, [params]);
        }
        else {
            this.params.get(token).push(params);
        }
    }
    getParamMetadata(token) {
        return this.params.get(token);
    }
    getParamMetadataKeys() {
        return Array.from(this.params.keys());
    }
    getPropMetadataKeys() {
        return Array.from(this.props.keys());
    }
    pushPropMetadata(token, params) {
        if (!this.props.has(token)) {
            this.props.set(token, [params]);
        }
        else {
            this.props.get(token).push(params);
        }
    }
    getPropMetadata(token) {
        return this.props.get(token);
    }
    pushMethodMetadata(token, params) {
        if (!this.methods.has(token)) {
            this.methods.set(token, [params]);
        }
        else {
            this.methods.get(token).push(params);
        }
    }
    getMethodMetadata(token) {
        return this.methods.get(token);
    }
}
